export default "__VITE_PUBLIC_ASSET__4120e594__"